export const environment = {
    production: false,
    apiUrl:'https://quality-gate-api-hml.enacloud.me',
    apiUrlBuffer: '',

    client: '',
    redirectUri: 'http://localhost:4200',
    authority: '',
  };
